// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner_lds_ring__oHpX\\+ {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 150px;
}
.spinner_lds_ring__oHpX\\+ div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: spinner_lds_ring__oHpX\\+ 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #1dd1a1 transparent transparent transparent;
}
.spinner_lds_ring__oHpX\\+ div:nth-child(1) {
  animation-delay: -0.45s;
}
.spinner_lds_ring__oHpX\\+ div:nth-child(2) {
  animation-delay: -0.3s;
}
.spinner_lds_ring__oHpX\\+ div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes spinner_lds_ring__oHpX\\+ {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner_lds_dual_ring__OpIlU {
  display: inline-block;
  width: 80px;
  height: 150px;
}
.spinner_lds_dual_ring__OpIlU:after {
  content: ' ';
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #1dd1a1 transparent #1dd1a1 transparent;
  animation: spinner_lds_dual_ring__OpIlU 1.2s linear infinite;
}
@keyframes spinner_lds_dual_ring__OpIlU {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner_lds_roller__7crwA {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 120px;
}
.spinner_lds_roller__7crwA div {
  animation: spinner_lds_roller__7crwA 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.spinner_lds_roller__7crwA div:after {
  content: ' ';
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1dd1a1;
  margin: -4px 0 0 -4px;
}
.spinner_lds_roller__7crwA div:nth-child(1) {
  animation-delay: -0.036s;
}
.spinner_lds_roller__7crwA div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.spinner_lds_roller__7crwA div:nth-child(2) {
  animation-delay: -0.072s;
}
.spinner_lds_roller__7crwA div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.spinner_lds_roller__7crwA div:nth-child(3) {
  animation-delay: -0.108s;
}
.spinner_lds_roller__7crwA div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.spinner_lds_roller__7crwA div:nth-child(4) {
  animation-delay: -0.144s;
}
.spinner_lds_roller__7crwA div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.spinner_lds_roller__7crwA div:nth-child(5) {
  animation-delay: -0.18s;
}
.spinner_lds_roller__7crwA div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.spinner_lds_roller__7crwA div:nth-child(6) {
  animation-delay: -0.216s;
}
.spinner_lds_roller__7crwA div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.spinner_lds_roller__7crwA div:nth-child(7) {
  animation-delay: -0.252s;
}
.spinner_lds_roller__7crwA div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.spinner_lds_roller__7crwA div:nth-child(8) {
  animation-delay: -0.288s;
}
.spinner_lds_roller__7crwA div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes spinner_lds_roller__7crwA {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner_lds_ellipsis__3xRAT {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.spinner_lds_ellipsis__3xRAT div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #1dd1a1;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.spinner_lds_ellipsis__3xRAT div:nth-child(1) {
  left: 8px;
  animation: spinner_lds_ellipsis1__-VyL4 0.6s infinite;
}
.spinner_lds_ellipsis__3xRAT div:nth-child(2) {
  left: 8px;
  animation: spinner_lds_ellipsis2__MQiKr 0.6s infinite;
}
.spinner_lds_ellipsis__3xRAT div:nth-child(3) {
  left: 32px;
  animation: spinner_lds_ellipsis2__MQiKr 0.6s infinite;
}
.spinner_lds_ellipsis__3xRAT div:nth-child(4) {
  left: 56px;
  animation: spinner_lds_ellipsis3__6lT7g 0.6s infinite;
}
@keyframes spinner_lds_ellipsis1__-VyL4 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes spinner_lds_ellipsis3__6lT7g {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes spinner_lds_ellipsis2__MQiKr {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.spinner_lds_ripple__vuvOc {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.spinner_lds_ripple__vuvOc div {
  position: absolute;
  border: 4px solid #1dd1a1;
  opacity: 1;
  border-radius: 50%;
  animation: spinner_lds_ripple__vuvOc 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.spinner_lds_ripple__vuvOc div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes spinner_lds_ripple__vuvOc {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.spinner_lds_boxbox__oNoUC {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.spinner_lds_boxbox__oNoUC div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #1dd1a1;
  animation: spinner_lds_boxbox__oNoUC 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.spinner_lds_boxbox__oNoUC div:nth-child(1) {
  left: 8px;
  animation-delay: 0.2s;
}
.spinner_lds_boxbox__oNoUC div:nth-child(2) {
  left: 32px;
  animation-delay: 0.4s;
}
.spinner_lds_boxbox__oNoUC div:nth-child(3) {
  left: 56px;
  animation-delay: 0.6s;
}
.spinner_lds_boxbox__oNoUC div:nth-child(4) {
  left: 80px;
  animation-delay: 0.8s;
}
.spinner_lds_boxbox__oNoUC div:nth-child(5) {
  left: 104px;
  animation-delay: 1s;
}
@keyframes spinner_lds_boxbox__oNoUC {
  0% {
    top: 8px;
    height: 64px;
  }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/spinner.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,8EAA8D;EAC9D,yDAAyD;AAC3D;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qDAAqD;EACrD,4DAA6C;AAC/C;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,+EAAgE;EAChE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,SAAS;EACT,qDAAsC;AACxC;AACA;EACE,SAAS;EACT,qDAAsC;AACxC;AACA;EACE,UAAU;EACV,qDAAsC;AACxC;AACA;EACE,UAAU;EACV,qDAAsC;AACxC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,6EAA8D;AAChE;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,+EAAgE;AAClE;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,QAAQ;IACR,YAAY;EACd;EACA;;IAEE,SAAS;IACT,YAAY;EACd;AACF","sourcesContent":[".lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 150px;\n}\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border: 8px solid #fff;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #1dd1a1 transparent transparent transparent;\n}\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.lds_dual_ring {\n  display: inline-block;\n  width: 80px;\n  height: 150px;\n}\n.lds_dual_ring:after {\n  content: ' ';\n  display: block;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border-radius: 50%;\n  border: 6px solid #fff;\n  border-color: #1dd1a1 transparent #1dd1a1 transparent;\n  animation: lds_dual_ring 1.2s linear infinite;\n}\n@keyframes lds_dual_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.lds_roller {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 120px;\n}\n.lds_roller div {\n  animation: lds_roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  transform-origin: 40px 40px;\n}\n.lds_roller div:after {\n  content: ' ';\n  display: block;\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #1dd1a1;\n  margin: -4px 0 0 -4px;\n}\n.lds_roller div:nth-child(1) {\n  animation-delay: -0.036s;\n}\n.lds_roller div:nth-child(1):after {\n  top: 63px;\n  left: 63px;\n}\n.lds_roller div:nth-child(2) {\n  animation-delay: -0.072s;\n}\n.lds_roller div:nth-child(2):after {\n  top: 68px;\n  left: 56px;\n}\n.lds_roller div:nth-child(3) {\n  animation-delay: -0.108s;\n}\n.lds_roller div:nth-child(3):after {\n  top: 71px;\n  left: 48px;\n}\n.lds_roller div:nth-child(4) {\n  animation-delay: -0.144s;\n}\n.lds_roller div:nth-child(4):after {\n  top: 72px;\n  left: 40px;\n}\n.lds_roller div:nth-child(5) {\n  animation-delay: -0.18s;\n}\n.lds_roller div:nth-child(5):after {\n  top: 71px;\n  left: 32px;\n}\n.lds_roller div:nth-child(6) {\n  animation-delay: -0.216s;\n}\n.lds_roller div:nth-child(6):after {\n  top: 68px;\n  left: 24px;\n}\n.lds_roller div:nth-child(7) {\n  animation-delay: -0.252s;\n}\n.lds_roller div:nth-child(7):after {\n  top: 63px;\n  left: 17px;\n}\n.lds_roller div:nth-child(8) {\n  animation-delay: -0.288s;\n}\n.lds_roller div:nth-child(8):after {\n  top: 56px;\n  left: 12px;\n}\n@keyframes lds_roller {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.lds_ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds_ellipsis div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #1dd1a1;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.lds_ellipsis div:nth-child(1) {\n  left: 8px;\n  animation: lds_ellipsis1 0.6s infinite;\n}\n.lds_ellipsis div:nth-child(2) {\n  left: 8px;\n  animation: lds_ellipsis2 0.6s infinite;\n}\n.lds_ellipsis div:nth-child(3) {\n  left: 32px;\n  animation: lds_ellipsis2 0.6s infinite;\n}\n.lds_ellipsis div:nth-child(4) {\n  left: 56px;\n  animation: lds_ellipsis3 0.6s infinite;\n}\n@keyframes lds_ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes lds_ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n@keyframes lds_ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(24px, 0);\n  }\n}\n\n.lds_ripple {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds_ripple div {\n  position: absolute;\n  border: 4px solid #1dd1a1;\n  opacity: 1;\n  border-radius: 50%;\n  animation: lds_ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.lds_ripple div:nth-child(2) {\n  animation-delay: -0.5s;\n}\n@keyframes lds_ripple {\n  0% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  4.9% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  5% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 0px;\n    left: 0px;\n    width: 72px;\n    height: 72px;\n    opacity: 0;\n  }\n}\n\n.lds_boxbox {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds_boxbox div {\n  display: inline-block;\n  position: absolute;\n  left: 8px;\n  width: 16px;\n  background: #1dd1a1;\n  animation: lds_boxbox 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;\n}\n.lds_boxbox div:nth-child(1) {\n  left: 8px;\n  animation-delay: 0.2s;\n}\n.lds_boxbox div:nth-child(2) {\n  left: 32px;\n  animation-delay: 0.4s;\n}\n.lds_boxbox div:nth-child(3) {\n  left: 56px;\n  animation-delay: 0.6s;\n}\n.lds_boxbox div:nth-child(4) {\n  left: 80px;\n  animation-delay: 0.8s;\n}\n.lds_boxbox div:nth-child(5) {\n  left: 104px;\n  animation-delay: 1s;\n}\n@keyframes lds_boxbox {\n  0% {\n    top: 8px;\n    height: 64px;\n  }\n  50%,\n  100% {\n    top: 24px;\n    height: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lds_ring": `spinner_lds_ring__oHpX+`,
	"lds_dual_ring": `spinner_lds_dual_ring__OpIlU`,
	"lds_roller": `spinner_lds_roller__7crwA`,
	"lds_ellipsis": `spinner_lds_ellipsis__3xRAT`,
	"lds_ellipsis1": `spinner_lds_ellipsis1__-VyL4`,
	"lds_ellipsis2": `spinner_lds_ellipsis2__MQiKr`,
	"lds_ellipsis3": `spinner_lds_ellipsis3__6lT7g`,
	"lds_ripple": `spinner_lds_ripple__vuvOc`,
	"lds_boxbox": `spinner_lds_boxbox__oNoUC`
};
export default ___CSS_LOADER_EXPORT___;
